import { Component, signal, ChangeDetectorRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { OnInit } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ReactiveFormsModule, CommonModule],
  templateUrl: './app.html',
  styleUrls: ['./app.css']
})
export class App implements OnInit {
  protected readonly title = signal('contact-form');
  siteKey = (environment as any).captchaSiteKey;
  privacyPolicyLink = environment.privacyPolicyLink;
  contactForm: FormGroup;
  showForm = true;
  showSuccess = false;
  showError = false;
  errorEmail = (environment as any).contactErrorEmail;
  apiUrl = (environment as any).functionAppUrl + '/SubmitContactForm';
  brandCode = (environment as any).BrandCode;
  submitting = false;

  constructor(
    private reCaptchaV3Service: ReCaptchaV3Service,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private http: HttpClient
  ) {
    this.contactForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
  subject: ['', [Validators.required, Validators.maxLength(50)]],
  description: ['', [Validators.required, Validators.maxLength(4000)]],
      privacyPolicy: [false, Validators.requiredTrue]
    });
  }

  ngOnInit(): void {
    // Reset form and state only on initial load
    this.showForm = true;
    this.showSuccess = false;
    this.showError = false;
    // Only reset if the form is pristine (first load)
    if (this.contactForm && this.contactForm.pristine) {
      this.contactForm.reset();
    }
  }

  onSubmit() {
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      return;
    }
  this.submitting = true;
    this.reCaptchaV3Service.execute(this.siteKey, 'contactForm', (token: string) => {
      this.onCaptchaResolved(token);
    });
  }

  onCaptchaResolved(token: string) {
    const formValue = this.contactForm.value;
    // Explicitly convert all line breaks to \n
    const descriptionWithExplicitNewlines = (formValue.description || '').replace(/\r?\n/g, '<br/>');
    const payload = {
      Captcha: token,
      contactForm: {
        BrandCode: this.brandCode,
        FirstName: formValue.firstName,
        LastName: formValue.lastName,
        Email: formValue.email,
        Subject: formValue.subject,
        Description: descriptionWithExplicitNewlines
      }
    };
    this.submitContactForm(payload).subscribe({
      next: res => {
        this.showForm = false;
        this.showSuccess = true;
        this.showError = false;
  this.submitting = false;
        this.cdr.detectChanges();
      },
      error: err => {
        this.showForm = false;
        this.showSuccess = false;
        this.showError = true;
  this.submitting = false;
        this.cdr.detectChanges();
      }
    });
  }

  submitContactForm(payload: any) {
  return this.http.post(this.apiUrl, {
    Captcha: payload.Captcha,
    contactForm: payload.contactForm
  });
}
}
